import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addloginChange from "./components/addloginChange.vue";
import { accountBindList } from "@/api/gmtool/packageCode";
import { gmTool } from "@/mixins/index";
import { times } from "lodash";
export default {
  name: "loginChange",
  mixins: [gmTool],
  components: {
    addloginChange: addloginChange
  },
  data: function data() {
    return {
      paramsData: {
        page: 1,
        is_prod: '',
        startTime: '',
        endTime: '',
        old_acc_id: '',
        new_acc_id: ''
      },
      selsString: '',
      date: []
    };
  },
  activated: function activated() {
    this.getList(this.currentPage);
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.reqLoading = true;
      this.paramsData.startTime = this.date ? this.date[0] : '';
      this.paramsData.endTime = this.date ? this.date[1] : '';
      this.paramsData.page = e;
      accountBindList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    toDetils: function toDetils(id) {
      this.$router.push({
        name: 'playerDetails',
        params: {
          is_prod: this.paramsData.is_prod,
          role_id: id
        }
      });
    },
    Renewal: function Renewal() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.tableData = [];

                _this2.getList();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 删除配置
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDelete'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                examineServerDel(_objectSpread({
                  id: id
                }, _this3.paramsData)).then(function (res) {
                  if (res.status == 200) {
                    _this3.getList(_this3.paramsData.page);

                    _this3.$message({
                      type: "success",
                      message: _this3.$t('deleteSuccess')
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};